<template>
  <router-view />
</template>

<script>
export default {
  name: 'FinanceOnSiteIndex'
}
</script>
